// extracted by mini-css-extract-plugin
export default {"formManualInput":"styles_formManualInput__vGZpu"};